import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

export type DisplaySettingsParams = {
  showBreadcrumbs: SettingsParamType.Boolean
  showTitle: SettingsParamType.Boolean
  showLocationTabs: SettingsParamType.Boolean
  showExperienceImage: SettingsParamType.Boolean
  showExperienceSummary: SettingsParamType.Boolean
  showExperienceDuration: SettingsParamType.Boolean
  showExperienceDate: SettingsParamType.Boolean
  showExperiencePrice: SettingsParamType.Boolean
}

export const DEFAULT_DISPLAY_SETTINGS_PARAMS: Record<keyof DisplaySettingsParams, any> = {
  showBreadcrumbs: true,
  showTitle: true,
  showLocationTabs: true,
  showExperienceImage: true,
  showExperienceSummary: true,
  showExperienceDuration: true,
  showExperienceDate: true,
  showExperiencePrice: true,
}

export const displaySettingsParams = createSettingsParams<DisplaySettingsParams>({
  showBreadcrumbs: {
    type: SettingsParamType.Boolean,
    inheritDesktop: false,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
  },
  showTitle: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showTitle,
  },
  showLocationTabs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showLocationTabs,
  },
  showExperienceImage: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceImage,
  },
  showExperienceSummary: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceSummary,
  },
  showExperienceDuration: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceDuration,
  },
  showExperienceDate: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceDate,
  },
  showExperiencePrice: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperiencePrice,
  },
})
